export class ApiRequestModel {
  public xAction: string;
  public xUserName: string;
  public xTimeZoneCode: number;
  public xLocationCode: number;
  public xRequestType: number;
  public xAuthGenKEY: string;
  public xLangCode: number;
}
